export const uk = {
    'column-title-city': 'Город',
    'column-title-feedbacks': 'Отзывы',
    'column-title-freelancers': 'Специалисты',
    'column-title-score': 'Оценки',
    'column-title-services': 'Стоимость и сроки',
    noScore: 'Мало отзывов'
};
